// import React, { useState } from 'react';
// import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
// import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
// import SeedsLogo from '../../../assets/images/SeedsLogo.png';
// import HomeSvg from '../../../components/SVG/HomeSvg';
// import { FiPlqus } from 'react-icons/fi';
// import './BranchOfficers.css';
// import CustomPagination from '../../../components/Pagination/CustomPagination';
// import ToggleButton from '../../../components/ToggleButton/ToggleButton';
// import { useNavigate } from 'react-router-dom';

// const BranchOfficers = () => {
//   const [currentPage, setCurrentPage] = useState(
//     parseInt(sessionStorage.getItem('currentPage')) || 1
//   );
//   const [limit, setLimit] = useState(
//     parseInt(sessionStorage.getItem('limit')) || 10
//   );
//   const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
//   const totalPages = Math.ceil(totalCount / limit);

//   const navigate = useNavigate();

//   const handlePageChange = (newPage) => {
//     // Ensure we're working with 1-based pagination
//     const pageToSet = Math.max(1, Math.min(newPage, totalPages));
//     setCurrentPage(pageToSet);
//     sessionStorage.setItem('currentPage', pageToSet.toString());
//   };

//   let officers = [
//     {
//       name: 'Sushmit',
//       employeeId: 'RO001',
//       designation: 'RO',
//       activeSince: 'Jan 12, 2025',
//       status: 'active',
//       lastChangesMade: '2 days ago',
//       emailId: 'user@seedsfincap.com',
//       password: '**********',
//       markStatus: true,
//     },
//     {
//       name: 'Ravi',
//       employeeId: 'BM001',
//       designation: 'BM',
//       activeSince: 'Jan 12, 2025',
//       status: 'active',
//       lastChangesMade: '2 days ago',
//       emailId: 'user@seedsfincap.com',
//       password: '**********',
//       markStatus: true,
//     },
//     {
//       name: 'Vinay',
//       employeeId: 'BCM001',
//       designation: 'BCM',
//       activeSince: 'Jan 12, 2025',
//       status: 'inactive',
//       lastChangesMade: '2 days ago',
//       emailId: 'user@seedsfincap.com',
//       password: '**********',
//       markStatus: false,
//     },
//   ];

//   return (
//     <Container fluid className="user-management">
//       {/* Logo */}
//       <div className="userContentHeader">
//         <div className="userLogo">
//           <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
//         </div>
//         <div className="headerRightPanel">
//           <UserProfileDropdown />
//         </div>
//       </div>

//       {/* Header */}
//       <Row className="branch-officers-header align-items-center">
//         <Col className="headerLeft">
//           <div onClick={() => navigate('/user-management')}>
//             <HomeSvg fillColor={'#002355'} />
//           </div>
//           <h5 className="title">Reporting Officers - Mumbai Central-RO001</h5>
//         </Col>
//         <Col className="text-end">
//           <Button
//             variant="primary"
//             style={{ backgroundColor: '#002355', border: 'none' }}
//           >
//             <FiPlus />
//             Add User
//           </Button>
//         </Col>
//       </Row>

//       <div className="dashboard-content">
//         {/* Search */}
//         <div className="my-4 search-row">
//           <Form.Control
//             type="text"
//             placeholder="Search by name, employee id or email ..."
//             className="search-input"
//           />
//           <button className="search-btn">Search</button>
//         </div>

//         <div className="officerTableContainer">
//           <table className="officers-table">
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Employee ID</th>
//                 <th>Designation</th>
//                 <th>Active Since</th>
//                 <th>Status</th>
//                 <th>Last Changes Made</th>
//                 <th>Email ID</th>
//                 <th>Password</th>
//                 <th>Mark Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {officers?.map((officer, index) => (
//                 <tr key={index}>
//                   <td>{officer?.name}</td>
//                   <td>{officer?.employeeId}</td>
//                   <td>{officer?.designation}</td>
//                   <td>{officer?.activeSince}</td>
//                   <td>
//                     <span className={`officerStatus ${officer?.status}`}>
//                       {officer?.status?.toUpperCase()}
//                     </span>
//                   </td>
//                   <td>{officer?.lastChangesMade}</td>
//                   <td>{officer?.emailId}</td>
//                   <td>{officer?.password}</td>
//                   {/* <td>{officer?.markStatus}</td> */}
//                   <td>
//                     <ToggleButton status={officer?.markStatus} />
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         <div className="paginationControls">
//           <CustomPagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={handlePageChange}
//           />
//         </div>
//       </div>
//     </Container>
//   );
// };

// export default BranchOfficers;

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Container, Row, Col, Button, Form, Dropdown } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import SeedsLogo from '../../../assets/images/SeedsLogo.png';
import { FiPlus } from 'react-icons/fi';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import './BranchOfficers.css';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import AddUserModal from '../AddUserModal/AddUserModal';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { getTimeAgo } from '../../../utils/dateTimeUtils';
import RoHandoverModal from '../RoHandoverModal/RoHandoverModal';
import AssignAnotherBranch from '../AssignAnotherBranch/AssignAnotherBranch';
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import ViewBranchesModal from '../ViewBranchesModal/ViewBranchesModal';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ToggleButton = ({
  status,
  onToggle,
  loading = false,
  disabled = false,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (!disabled && !loading) {
      onToggle();
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <button
        style={{
          position: 'relative',
          width: '48px',
          height: '24px',
          borderRadius: '12px',
          border: 'none',
          cursor: disabled || loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s ease',
          padding: 0,
          outline: 'none',
          backgroundColor: status ? '#4caf50' : '#ccc',
          opacity: loading || disabled ? 0.6 : 1,
        }}
        onClick={handleClick}
        disabled={disabled || loading}
        aria-label={status ? 'Deactivate user' : 'Activate user'}
        aria-pressed={!!status}
      >
        <div
          style={{
            position: 'absolute',
            top: '2px',
            left: '2px',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: 'white',
            transition: 'transform 0.3s ease',
            transform: status ? 'translateX(24px)' : 'translateX(0)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {loading && (
            <div
              style={{
                width: '12px',
                height: '12px',
                border: '2px solid #002355',
                borderTopColor: 'transparent',
                borderRadius: '50%',
                animation: 'spin 0.6s linear infinite',
              }}
            />
          )}
        </div>
      </button>
      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

const BranchOfficers = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const branchCode = searchParams.get('branch');
  const branchName = searchParams.get('name');
  const stateName = searchParams.get('state');

  // Data states
  const [officers, setOfficers] = useState([]);
  const [filteredOfficers, setFilteredOfficers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [toggleLoading, setToggleLoading] = useState({});

  // Password visibility state
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const [searchQuery, setSearchQuery] = useState('');
  const debounceRef = useRef(null);

  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [showRoHandoverModal, setShowRoHandoverModal] = useState(false);
  const [roOfficerToDisable, setRoOfficerToDisable] = useState(null);
  const [selectedNewRo, setSelectedNewRo] = useState("");

  const [showAssignAnotherBranchModal, setShowAssignAnotherBranchModal] = useState(false);
  const [showViewBranchesModal, setShowViewBranchesModal] = useState(false);
  const [selectedOfficer, setSelectedOfficer] = useState(null);

  const getToken = () => {
    try {
      const tokensString = sessionStorage.getItem('tokens');
      if (tokensString) {
        const tokensObject = JSON.parse(tokensString);
        return tokensObject.token || '';
      }
      return sessionStorage.getItem('token') || '';
    } catch (error) {
      console.error('Error parsing tokens:', error);
      return sessionStorage.getItem('token') || '';
    }
  };

  const togglePasswordVisibility = (officerId) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [officerId]: !prev[officerId],
    }));
  };

  const fetchOfficers = async () => {
    if (!branchCode) {
      setError('Branch code is missing');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = getToken();
      const response = await axios.get(
        `${API_BASE_URL}/officer/get-branch-officer-report`,
        {
          params: {
            page: 1,
            limit: 100,
            is_download: false,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            accept: '*/*',
          },
        }
      );

      if (response.data && response.data.status) {
        const apiData = response.data.data;
        const allOfficers = apiData.officers || [];
        const branchData = allOfficers.find(
          (b) => b.branch_code === branchCode
        );

        if (branchData && branchData.officer_details) {
      const officerList = branchData.officer_details.map((officer) => ({
            name:
              `${officer.first_name || ''} ${officer.last_name || ''}`.trim() ||
              'N/A',
            employeeId: officer.emp_id || 'N/A',
            designation: officer.role_code || 'N/A', // kept for internal logic (e.g. RO handover check), no longer rendered as its own column
            roleName: officer.role_name || 'N/A', // NEW
            department: officer.department || 'N/A', // NEW
            // activeSince: officer.last_active_at ? dayjs(officer.last_active_at).format("MMM DD, YYYY HH:mm:ss") : "-",
            // activeSince: officer.last_active_at ? dayjs(officer.last_active_at).format("MMM DD, YYYY") : "-",
            activeSince: officer.last_active_at ? dayjs(officer.last_active_at).format("YYYY-MM-DD") : "-",
            status: officer.is_active ? 'active' : 'inactive',
            // lastChangesMade: officer.is_login
            //   ? 'Recently logged in'
            //   : 'Not logged in',
            lastChangesMade: getTimeAgo(officer.last_active_at),
            emailId: officer.email || 'N/A',
            password: officer.password || '**********',
            officerId: officer.officer_id,
            isLogin: officer.is_login,
            markStatus: officer.is_active,
            secondaryBranches: officer?.secondary_branches,
            associations: (Array.isArray(officer?.secondary_branches) && officer.secondary_branches.length > 0)
              ? ['SECONDARY']
              : []
          }));

          setOfficers(officerList);
          setFilteredOfficers(officerList);
          setTotalPages(Math.ceil(officerList.length / limit));
          setCurrentPage(1);
        } else {
          setOfficers([]);
          setFilteredOfficers([]);
          setTotalPages(1);
          setCurrentPage(1);
        }
      }
    } catch (err) {
      console.error('Error fetching officers:', err);
      setError('Failed to fetch officers data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOfficers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchCode]);

  const handlePageChange = (newPage) => {
    const pageToSet = Math.max(1, Math.min(newPage, totalPages));
    setCurrentPage(pageToSet);
  };

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      const q = (searchQuery || '').trim().toLowerCase();

      if (!q) {
        setFilteredOfficers(officers);
        setTotalPages(Math.max(1, Math.ceil(officers.length / limit)));
        setCurrentPage(1);
        return;
      }

      const filtered = officers.filter((officer) => {
        const name = (officer.name || '').toLowerCase();
        const empId = String(officer.employeeId || '').toLowerCase();
        const designation = (officer.designation || '').toLowerCase();
        const email = (officer.emailId || '').toLowerCase();

        return (
          name.includes(q) ||
          empId.includes(q) ||
          designation.includes(q) ||
          email.includes(q)
        );
      });

      setFilteredOfficers(filtered);
      setTotalPages(Math.max(1, Math.ceil(filtered.length / limit)));
      setCurrentPage(1);
    }, 300);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchQuery, officers]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (debounceRef.current) clearTimeout(debounceRef.current);

      const q = (searchQuery || '').trim().toLowerCase();

      if (!q) {
        setFilteredOfficers(officers);
        setTotalPages(Math.max(1, Math.ceil(officers.length / limit)));
        setCurrentPage(1);
        return;
      }

      const filtered = officers.filter((officer) => {
        const name = (officer.name || '').toLowerCase();
        const empId = String(officer.employeeId || '').toLowerCase();
        const designation = (officer.designation || '').toLowerCase();
        const email = (officer.emailId || '').toLowerCase();

        return (
          name.includes(q) ||
          empId.includes(q) ||
          designation.includes(q) ||
          email.includes(q)
        );
      });

      setFilteredOfficers(filtered);
      setTotalPages(Math.max(1, Math.ceil(filtered.length / limit)));
      setCurrentPage(1);
    }
  };

  const clearSearch = () => {
    setSearchQuery('');
    setFilteredOfficers(officers);
    setTotalPages(Math.max(1, Math.ceil(officers.length / limit)));
    setCurrentPage(1);
  };

  const handleToggleStatus = async (officerId, currentStatus, handOverOfficerId = null) => {
    const token = getToken();

    if (!token) {
      alert('Authentication token not found. Please login again.');
      return;
    }

    setToggleLoading((prev) => ({ ...prev, [officerId]: true }));

    const originalOfficers = [...officers];
    const originalFilteredOfficers = [...filteredOfficers];

    const updatedOfficers = officers.map((officer) => {
      if (officer.officerId === officerId) {
        return {
          ...officer,
          markStatus: !currentStatus,
          status: !currentStatus ? 'active' : 'inactive',
        };
      }
      return officer;
    });

    const updatedFilteredOfficers = filteredOfficers.map((officer) => {
      if (officer.officerId === officerId) {
        return {
          ...officer,
          markStatus: !currentStatus,
          status: !currentStatus ? 'active' : 'inactive',
        };
      }
      return officer;
    });

    setOfficers(updatedOfficers);
    setFilteredOfficers(updatedFilteredOfficers);

    console.log("toggle officer ", {
      officer_id: officerId,
      branch_code: branchCode,
      ...(handOverOfficerId && { handover_officer_id: handOverOfficerId })
    })

    try {
      const response = await axios.put(
        // `${API_BASE_URL}/officer/profile/toggle-status/${officerId}/${branchCode}`,
        `${API_BASE_URL}/officer/profile/toggle-status`,
        {
          officer_id: officerId,
          branch_code: branchCode,
          ...(handOverOfficerId && { handover_officer_id: handOverOfficerId })
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            accept: '*/*',
          },
        }
      );

      if (response.data.status) {
        console.log('Status toggled successfully:', response.data);
        toast.success(`${response?.data?.message}`);
        fetchOfficers();
      } else {
        setOfficers(originalOfficers);
        setFilteredOfficers(originalFilteredOfficers);
        alert(response.data.message || 'Failed to toggle status');
      }
    } catch (err) {
      console.error('Error toggling status:', err);
      setOfficers(originalOfficers);
      setFilteredOfficers(originalFilteredOfficers);
      alert(
        err.response?.data?.message ||
        'Failed to toggle officer status. Please try again.'
      );
      fetchOfficers();
    } finally {
      setToggleLoading((prev) => ({ ...prev, [officerId]: false }));
    }
  };

  const getPaginatedOfficers = () => {
    const startIndex = (currentPage - 1) * limit;
    const endIndex = startIndex + limit;
    return filteredOfficers.slice(startIndex, endIndex);
  };

  const openAddUserModal = (branch = null) => {
    setSelectedBranch({
      branch_code: branch
    });
    setShowAddUserModal(true);
  };

  const closeAddUserModal = () => {
    setShowAddUserModal(false);
    setSelectedBranch(null);

    fetchOfficers();
  };

  const closeAssignAnotherBranchUserModal = () => {
    setShowAssignAnotherBranchModal(false);
    setSelectedOfficer(null);
    setSelectedBranch(null);

    fetchOfficers();
  };

  const closeViewBranchesModal = () => {
    setShowViewBranchesModal(false);
    setSelectedOfficer(null);
    fetchOfficers();
  };

  return (
    <Container fluid className="user-management">
      <div className="userContentHeader">
        <div className="userLogo">
          <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
        </div>
        <div className="headerRightPanel">
          <UserProfileDropdown />
        </div>
      </div>

      {/* Header */}
      <Row className="branch-officers-header align-items-center mb-4">
        <Col className="headerLeft">
          <div className="col-auto">
            <button
              type="button"
              className="btn btn-outline-primary btn-md back-to-dashboard"
              onClick={() => navigate('/user-management')}
            >
              ← Back to Dashboard
            </button>
          </div>
          <h5 className="title">
            Reporting Officers - {branchName || 'Branch'} - {branchCode}
            {stateName && ` • ${stateName}`}
          </h5>
        </Col>
        <Col className="text-end">
          <Button
            className="search-btn d-inline-flex align-items-center gap-2"
            onClick={() => openAddUserModal(branchCode)}
          >
            <FiPlus size={18} />
            <span>Add User</span>
          </Button>
        </Col>
      </Row>

      {
        showAddUserModal && (
          <AddUserModal
            closeModal={closeAddUserModal}
            selectedBranch={selectedBranch}
          />
        )
      }

      <div className="dashboard-content">
        {/* Search */}
        <div className="my-4 search-row">
          <Form.Control
            type="text"
            placeholder="Search by name, employee id, email or designation..."
            className="search-input"
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
          />

          <button
            className="search-btn"
            onClick={() => {
              if (searchQuery) clearSearch();
            }}
            title={searchQuery ? 'Clear search' : 'Search'}
          >
            {searchQuery ? '×' : 'Search'}
          </button>
        </div>

        {/* Loading and Error States */}
        {loading && (
          <div className="text-center my-4">
            <p>Loading officers...</p>
          </div>
        )}

        {error && (
          <div className="text-center my-4">
            <p className="text-danger">{error}</p>
          </div>
        )}

        {/* Officers Table */}
        {!loading && filteredOfficers.length > 0 ? (
          <>
            <div className="officerTableContainer">
              <table className="officers-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Employee ID</th>
                    <th>Role Name</th>
                    <th>Department</th>
                    <th>Active Since</th>
                    {/* <th>Status</th> */}
                    <th>Last Changes Made</th>
                    <th>Email ID</th>
                    <th>Branch Associations</th>
                    {/* <th>Password</th> */}
                    <th>Mark Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {getPaginatedOfficers().map((officer, index) => (
                    <tr key={officer.officerId || index}>
                      <td>{officer.name}</td>
                      <td>{officer.employeeId}</td>
                      {/* <td>{officer.designation}</td> */}
                       <td>{officer.roleName}</td>
                      <td>{officer.department}</td>
                      <td>{officer.activeSince}</td>
                      {/* <td>
                        <span className={`officerStatus ${officer.status}`}>
                          {officer.status.toUpperCase()}
                        </span>
                      </td> */}
                      <td>{officer.lastChangesMade}</td>
                      <td>{officer.emailId}</td>
                      <td className="tag-list">
                        {officer?.associations?.map(a => {
                          return (
                            <span className={`tag ${a?.toLowerCase()}-tag`}>{a}</span>
                          )
                        })}
                      </td>
                      {/* <td>
                        <div className="password-cell">
                          <span className="password-text">
                            {visiblePasswords[officer.officerId]
                              ? officer.password
                              : '••••••••••'}
                          </span>
                          <button
                            className="password-toggle-btn"
                            onClick={() =>
                              togglePasswordVisibility(officer.officerId)
                            }
                            aria-label={
                              visiblePasswords[officer.officerId]
                                ? 'Hide password'
                                : 'Show password'
                            }
                            title={
                              visiblePasswords[officer.officerId]
                                ? 'Hide password'
                                : 'Show password'
                            }
                          >
                            {visiblePasswords[officer.officerId] ? (
                              <AiOutlineEye />
                            ) : (
                              <AiOutlineEyeInvisible />
                            )}
                          </button>
                        </div>
                      </td> */}
                      <td>
                        <ToggleButton
                          status={officer.markStatus}
                          onToggle={() => {
                            if (officer?.designation === "RO" && officer?.markStatus === true) {
                              setRoOfficerToDisable(officer);
                              setShowRoHandoverModal(true);
                            }
                            else {
                              handleToggleStatus(
                                officer.officerId,
                                officer.markStatus
                              )
                            }

                          }}
                          loading={toggleLoading[officer.officerId]}
                          disabled={toggleLoading[officer.officerId]}
                        />
                      </td>
                      <td>
                        <Dropdown align="end">
                          <Dropdown.Toggle
                            id="user-table-action-dd"
                          >
                            <ThreeDotsVertical />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setSelectedOfficer(officer);
                                setShowAssignAnotherBranchModal(true);
                              }}
                            >
                              Assign Secondary Branch
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSelectedOfficer(officer);
                                setShowViewBranchesModal(true);
                              }}
                            >
                              View Other Branches
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Summary */}
            <div className="my-3">
              <p className="text-muted">
                Showing {(currentPage - 1) * limit + 1} to{' '}
                {Math.min(currentPage * limit, filteredOfficers.length)} of{' '}
                {filteredOfficers.length} officers
              </p>
            </div>
          </>
        ) : (
          !loading && (
            <div className="text-center my-4">
              <p>No officers found for this branch</p>
            </div>
          )
        )}

        {/* Pagination */}
        {!loading && totalPages > 1 && (
          <div className="paginationControls">
            <CustomPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}

        {/* RO Toggle Modal */}
        {
          showRoHandoverModal &&
          <RoHandoverModal
            officers={officers}
            showRoHandoverModal={showRoHandoverModal}
            setShowRoHandoverModal={setShowRoHandoverModal}
            selectedNewRo={selectedNewRo}
            setSelectedNewRo={setSelectedNewRo}
            roOfficerToDisable={roOfficerToDisable}
            setRoOfficerToDisable={setRoOfficerToDisable}
            handleToggleStatus={handleToggleStatus}
          />
        }

        {
          showAssignAnotherBranchModal &&
          <AssignAnotherBranch
            closeModal={closeAssignAnotherBranchUserModal}
            selectedOfficer={selectedOfficer}
            selectedBranch={selectedBranch}
          />
        }

        {
          showViewBranchesModal &&
          <ViewBranchesModal
            closeModal={closeViewBranchesModal}
            selectedOfficer={selectedOfficer}
          />
        }
      </div>
    </Container>
  );
};

export default BranchOfficers;
